<template>
    <div>
        <div class="card-body">
            <div class="card-text">
                <b-row row wrap>
                    <b-col cols="12" md="6">
                        <div class="form-group">
                            <app-form-text-input
                                label="Nombre"
                                id="name"
                                :required="true"
                                :hasError="$v.theClient.name.$error"
                                errorMessage="Debe escribir el nombre"
                                @input="$v.theClient.name.$touch()"
                                v-model="theClient.name"
                            ></app-form-text-input>
                        </div>
                    </b-col>
                    <b-col cols="12" md="6">
                        <div class="form-group">
                            <app-form-select-input
                                label="Ciudad"
                                :options="cities"
                                :hasError="$v.theClient.cityId.$error"
                                errorMessage="Debe seleccionar la ciudad"
                                @change="$v.theClient.cityId.$touch()"
                                v-model="theClient.cityId"
                                :required="true"
                            />
                        </div>
                    </b-col>
                    <b-col cols="12" md="6">
                        <div class="form-group">
                            <app-form-select-input
                                label="Tipo de cliente"
                                :options="clientTypes"
                                :hasError="$v.theClient.clientTypeId.$error"
                                errorMessage="Debe seleccionar el tipo de cliente"
                                @change="$v.theClient.clientTypeId.$touch()"
                                v-model="theClient.clientTypeId"
                                :required="true"
                            />
                        </div>
                    </b-col>
                    <b-col cols="12" md="6">
                        <div class="form-group">
                            <app-form-select-input
                                label="Tipo de identificación"
                                :options="identificationTypes"
                                :hasError="
                                    $v.theClient.identificationType.$error
                                "
                                errorMessage="Debe seleccionar el tipo de identificación"
                                @change="
                                    $v.theClient.identificationType.$touch()
                                "
                                v-model="theClient.identificationType"
                                :required="true"
                            />
                        </div>
                    </b-col>
                    <b-col cols="12" md="6">
                        <div class="form-group">
                            <app-form-text-input
                                label="Número de identificación"
                                id="document"
                                :required="true"
                                :hasError="$v.theClient.document.$error"
                                errorMessage="Debe escribir el documento"
                                @input="$v.theClient.document.$touch()"
                                v-model="theClient.document"
                            ></app-form-text-input>
                        </div>
                    </b-col>
                    <b-col cols="12" md="6">
                        <div class="form-group">
                            <app-form-text-input
                                label="Telefono"
                                id="phone"
                                v-model="theClient.phone"
                            ></app-form-text-input>
                        </div>
                    </b-col>
                    <b-col cols="12" md="6">
                        <div class="form-group">
                            <app-form-text-input
                                label="Dirección"
                                id="address"
                                v-model="theClient.address"
                            ></app-form-text-input>
                        </div>
                    </b-col>
                    <b-col cols="12" md="6">
                        <div class="form-group">
                            <app-form-text-input
                                label="Website"
                                id="website"
                                v-model="theClient.website"
                            ></app-form-text-input>
                        </div>
                    </b-col>
                    <b-col cols="12" md="6">
                        <app-form-text-input
                            label="E-mail"
                            id="email"
                            :required="true"
                            :hasError="$v.theClient.email.$error"
                            errorMessage="Debe escribir un email valido"
                            @input="$v.theClient.email.$touch()"
                            v-model="theClient.email"
                        ></app-form-text-input>
                    </b-col>
                    <b-col cols="12" md="6">
                        <app-form-select-input
                            label="Ejecutivo de cuenta"
                            v-model="theClient.accountExecutive"
                            :options="executives"
                        />
                    </b-col>
                    <b-col cols="12" md="6">
                        <app-form-select-input
                            label="Supervisor Encargado"
                            v-model="theClient.supervisorId"
                            :options="theSupervisors"
                        />
                    </b-col>
                    <b-col cols="12" md="6">
                        <app-form-select-input
                            label="Ejecutivo Supervisor"
                            v-model="theClient.supervisorExecutiveId"
                            :options="executives"
                        />
                    </b-col>
                    <b-col cols="12" class="mt-3">
                        <b-form-checkbox
                            v-if="enableCheckProspect"
                            v-model="theClient.futureClient"
                            >Cliente prospecto?</b-form-checkbox
                        >
                    </b-col>
                    <b-col cols="12" class="mt-3">
                        <b-form-group label="Lineas de negocio">
                            <b-form-checkbox
                                v-for="bl in businessLines"
                                :key="bl.id"
                                :value="bl.id"
                                v-model="theClient.businessLines"
                                name="business-lines"
                                inline
                                >{{ bl.name }} ({{ bl.code }})</b-form-checkbox
                            >
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" v-if="!this.myClient">
                        <b-form-checkbox
                            v-model="theClient.createUser"
                            :state="theClient.createUser"
                            >Crear usuario y notificar</b-form-checkbox
                        >
                        <br />
                        <small class="text-muted">
                            Crea un usuario automáticamente para el cliente y lo
                            notifica por correo electrónico
                        </small>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>
<script>
import { required, email } from 'vuelidate/lib/validators'
import FormTextInput from '../../UI/Controls/Forms/FormTextInput.vue'
import FormSelectInput from '../../UI/Controls/Forms/FormSelectInput.vue'
import clientsRepository from '../../../repositories/clients.repository'
import localizationRepository from '../../../repositories/localizationRepository'
import { mapGetters } from 'vuex'
import usersRepository from '@repositories/users.repository'
import businessLinesRepository from '@repositories/businessLines.repository'

export default {
    components: {
        appFormTextInput: FormTextInput,
        appFormSelectInput: FormSelectInput,
    },

    props: {
        myClient: {
            default: null,
        },
        onSave: {
            type: Function,
        },
        onEdit: {
            type: Function,
        },
    },

    data() {
        return {
            theClient: {
                name: '',
                identificationType: '',
                document: '',
                address: '',
                phone: '',
                email: '',
                website: '',
                clientTypeId: '',
                userId: '',
                createUser: true,
                cityId: '',
                accountExecutive: '',
                businessLines: [],
                supervisorId: '',
                supervisorExecutiveId: '',
                futureClient: false,
            },
            businessLines: [],
            prospectFlag: false,
            enableCheckProspect: false,
        }
    },

    validations: {
        theClient: {
            name: { required },
            identificationType: { required },
            clientTypeId: { required },
            document: { required },
            email: { email, required },
            cityId: { required },
            businessLines: { required },
        },
    },

    watch: {
        myClient(val) {
            this.fillForm()
        },
    },
    computed: {
        ...mapGetters([
            'clientTypes',
            'cities',
            'identificationTypes',
            'executives',
            'supervisors',
        ]),
        theSupervisors() {
            return this.supervisors.map(item => ({
                ...item,
                name: !!item.deleted_at ? `${item.name} (Inactivo)` : item.name,
            }))
        },
    },
    methods: {
        async registerClient() {
            this.$v.$touch()
            if (this.$v.$invalid) {
                toastr.error(
                    'Debe diligenciar correctamente todos los campos obligatorios'
                )
                return false
            }
            //Id del usuario que registro el cliente
            this.theClient.userId = this.user.id

            //const cr = { ...clientsRepository }

            try {
                //const { data } = await cr.saveClient(this.theClient)
                const { data } = await repo.post('clients', this.theClient)

                if (data.status) {
                    toastr.success(data.msg)
                    typeof this.onSave === 'function' && this.onSave(data)
                    this.cleanFields()
                    // Object.keys(this.theClient).map(
                    //     key => (this.theClient[key] = '')
                    // )
                    // this.$v.$reset()
                } else {
                    toastr.error(data.msg)
                }
            } catch (err) {
                this.handleErrors(err)
            }
        },
        updateClient() {
            this.$v.$touch()
            if (this.$v.$invalid) {
                toastr.error(
                    'Debe diligenciar correctamente todos los campos obligatorios'
                )
                return false
            }

            const payload = {
                ...this.theClient,
                userId: this.user.id,
                prospectFlag: this.prospectFlag,
            }

            const cr = Object.assign({}, clientsRepository)
            cr.updateClient(payload, this.myClient.id)
                .then(data => {
                    if (data.status) {
                        toastr.success(data.msg)
                        Object.keys(this.theClient).map(
                            key => (this.theClient[key] = '')
                        )
                        this.$v.$reset()
                        typeof this.onEdit === 'function' && this.onEdit(data)
                    } else {
                        toastr.error(data.msg)
                    }
                })
                .catch(error => {
                    this.handleErrors(error)
                })
        },
        cleanFields() {
            Object.keys(this.theClient).map(
                key =>
                    !['createUser', 'businessLines'].includes(key) &&
                    (this.theClient[key] = '')
            )
            this.theClient.createUser = true
            this.theClient.businessLines = []
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },
        SaveOrUpdate() {
            if (!!this.myClient) {
                this.updateClient()
            } else {
                this.registerClient()
            }
        },
        fillForm() {
            if (Object.keys(this.myClient).length !== 0) {
                this.theClient.identificationType = this.myClient.identification_type_id
                this.theClient.name = this.myClient.name
                this.theClient.document = this.myClient.document
                this.theClient.address = this.myClient.address
                this.theClient.phone = this.myClient.phone
                this.theClient.email = this.myClient.email
                this.theClient.website = this.myClient.website
                this.theClient.clientTypeId = this.myClient.client_type_id
                this.theClient.cityId = this.myClient.city.id
                this.theClient.futureClient =
                    this.myClient.prospect === 1 ? true : false

                this.prospectFlag = this.myClient.prospectFlag
                !!this.myClient.account_executive_id &&
                    (this.theClient.accountExecutive = this.myClient.account_executive_id)

                !!this.myClient.supervisor_id &&
                    (this.theClient.supervisorId = this.myClient.supervisor_id)

                !!this.myClient.supervisor_executive_id &&
                    (this.theClient.supervisorExecutiveId = this.myClient.supervisor_executive_id)

                console.log(this.myClient.business_lines)
                this.myClient.business_lines.map(line =>
                    this.theClient.businessLines.push(line.id)
                )
                this.enableCheckProspect = this.myClient.prospect ? true : false
            } else {
                this.cleanFields()
            }
        },
        async loadBusinessLines() {
            const blr = { ...businessLinesRepository }
            try {
                const { data } = await blr.get()
                this.businessLines = data
            } catch (err) {
                toastr.error(
                    `Ocurrió un error al cargar las lineas de negocio [${err.message}]`
                )
            }
        },
        changeStateCheckProspect() {
            this.enableCheckProspect = true
        },
    },
    created() {
        this.load('identificationTypes')
        this.load('clientTypes')
        this.load('cities')
        this.load('executives')
        this.load('supervisors')
        // this.loadAccountExecutives();
        this.loadBusinessLines()
        // this.cleanFields();
        this.$bus.$on('client-form.save', this.SaveOrUpdate)
        this.$bus.$on('client-form.clean', this.cleanFields)
    },

    beforeDestroy() {
        this.$bus.$off('client-form.save')
    },
    mounted() {},
}
</script>
